import { Dimensions, Modal, StyleSheet, View } from 'react-native';
import { Colors } from '../../../themes/colors';
import { NewAlertForm } from './newAlertForm';

type NewAlertModalProps = {
  newAlertModalVisible: boolean;
  onClose: () => void;
  routineId: string;
  workspaceAssetId: string;
  productId?: string;
  workspace?: string;
};

export const NewAlertModal = ({
  newAlertModalVisible,
  onClose,
  routineId,
  workspaceAssetId,
  productId,
  workspace,
}: NewAlertModalProps) => {
  return (
    <Modal
      visible={newAlertModalVisible}
      transparent={true}
      onRequestClose={onClose}
    >
      <View style={styles.webModalBackground}>
        <View style={styles.modalContainer}>
          <NewAlertForm
            routineId={routineId}
            workspaceAssetId={workspaceAssetId}
            onClose={onClose}
            productId={productId}
            workspace={workspace}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  webModalBackground: {
    flex: 1,
    backgroundColor: Colors.role.inverseDim,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 560,
    minHeight: 461,
    maxHeight: Dimensions.get('window').height * 0.8,
    backgroundColor: Colors.role.surfaceHover,
    borderRadius: 12,
    overflow: 'hidden',
    elevation: 10,
  },
});
